/* global axios */
import ApiClient from './ApiClient';

/**
 * SurveyFormsAPI — unified survey builder.
 *
 * A survey form owns its questions AND the screen shown after submission, so
 * the whole public experience is authored in the dashboard instead of living in
 * ERB templates. Responses are read through the nested collection (per form) or
 * the flat one (across forms, for reporting).
 */
class SurveyFormsAPI extends ApiClient {
  constructor() {
    super('survey_forms', { accountScoped: true });
  }

  duplicate(id) {
    return axios.post(`${this.url}/${id}/duplicate`);
  }

  friendlyLink(id, payload) {
    return axios.post(`${this.url}/${id}/friendly_link`, payload);
  }

  friendlyLinks(id, params = {}) {
    return axios.get(`${this.url}/${id}/friendly_links`, { params });
  }

  friendlyLinkDeliveryOptions(id, params = {}, options = {}) {
    return axios.get(`${this.url}/${id}/friendly_link_delivery_options`, {
      params,
      signal: options.signal,
    });
  }

  friendlyLinkHandoverOptions(id, params = {}, options = {}) {
    return axios.get(`${this.url}/${id}/friendly_link_handover_options`, {
      params,
      signal: options.signal,
    });
  }

  friendlyLinkContractOptions(id, params = {}, options = {}) {
    return axios.get(`${this.url}/${id}/friendly_link_contract_options`, {
      params,
      signal: options.signal,
    });
  }

  friendlyLinkMaintenanceOptions(id, params = {}, options = {}) {
    return axios.get(`${this.url}/${id}/friendly_link_maintenance_options`, {
      params,
      signal: options.signal,
    });
  }

  friendlyLinkInspectionOptions(id, params = {}, options = {}) {
    return axios.get(`${this.url}/${id}/friendly_link_inspection_options`, {
      params,
      signal: options.signal,
    });
  }

  revokeFriendlyLink(id, linkId) {
    return axios.post(`${this.url}/${id}/friendly_links/${linkId}/revoke`);
  }

  responses(id, params = {}) {
    return axios.get(`${this.url}/${id}/survey_responses`, { params });
  }
}

export default new SurveyFormsAPI();
